import { render, staticRenderFns } from "./ZushinCover.vue?vue&type=template&id=2a4761b4&"
import script from "./ZushinCover.vue?vue&type=script&lang=js&"
export * from "./ZushinCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4761b4')) {
      api.createRecord('2a4761b4', component.options)
    } else {
      api.reload('2a4761b4', component.options)
    }
    module.hot.accept("./ZushinCover.vue?vue&type=template&id=2a4761b4&", function () {
      api.rerender('2a4761b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/ZushinCover.vue"
export default component.exports